import { render, staticRenderFns } from "./PageCheckout.vue?vue&type=template&id=1120bf44&"
import script from "./PageCheckout.vue?vue&type=script&lang=js&"
export * from "./PageCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1120bf44')) {
      api.createRecord('1120bf44', component.options)
    } else {
      api.reload('1120bf44', component.options)
    }
    module.hot.accept("./PageCheckout.vue?vue&type=template&id=1120bf44&", function () {
      api.rerender('1120bf44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageCheckout.vue"
export default component.exports